import Vue from 'vue';

export function notify(message, options = {}) {
    Vue.$toast.open({
        message,
        type: 'default',
        duration: 3000,
        position: (screen.width < 992) ? 'bottom' : 'bottom-right',
        ...options,
    });
}

export function trans(key, replace = {}) {
    let translation = window.App.translations[key];
    for (let key in replace) {
        translation = translation.replace(`:${key}`, replace[key]);
    }
    return translation;
}

export function isEmpty(value) {
    return $.isEmptyObject(value);
}

export function chunk(array, size) {
    let chunkedArray = [];
    let index = 0;

    while (index < array.length) {
        chunkedArray.push(array.slice(index, size + index));
        index += size;
    }

    return chunkedArray;
}

export function slickPrevArrow() {
    if (window.App.rtl) {
        return `<div class="arrow-prev">
                    <i class="las la-angle-right"></i> ${trans('frontend::layout.prev')}
                </div>`;
    }

    return `<div class="arrow-prev">
                <i class="las la-angle-left"></i> ${trans('frontend::layout.prev')}
            </div>`;
}

export function slickNextArrow() {
    if (window.App.rtl) {
        return `<div class="arrow-next">
                    ${trans('frontend::layout.next')} <i class="las la-angle-left"></i>
                </div>`;
    }

    return `<div class="arrow-next">
                ${trans('frontend::layout.next')} <i class="las la-angle-right"></i>
            </div>`;
}
